"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _useGraph3 = _interopRequireDefault(require("./useGraph"));

var _react = require("react");

var _query = require("../graphql/query");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useGetAwyesContent = function useGetAwyesContent() {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useGraph = (0, _useGraph3["default"])(_query.getAwyesContent),
      _useGraph2 = _slicedToArray(_useGraph, 2),
      _useGraph2$ = _useGraph2[0],
      error = _useGraph2$.error,
      loading = _useGraph2$.loading,
      complete = _useGraph2$.complete,
      _useGraph2$$data = _useGraph2$.data;

  _useGraph2$$data = _useGraph2$$data === void 0 ? {} : _useGraph2$$data;
  var rawItems = _useGraph2$$data.items,
      notFound = _useGraph2$$data.notFound,
      request = _useGraph2[1].request;
  var requestWithVars = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _doRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(awyesIds) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              doRequest.aborted = false;

              if (!(awyesIds !== null && awyesIds !== void 0 && awyesIds.length)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return request({
                query: {
                  awyesIds: awyesIds
                }
              }, function () {
                return doRequest.aborted;
              });

            case 4:
              _context.next = 7;
              break;

            case 6:
              setItems([]);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function doRequest(_x) {
      return _doRequest.apply(this, arguments);
    }

    return doRequest;
  }(), [request]);
  (0, _react.useEffect)(function () {
    if (complete) {
      setItems(rawItems !== null && rawItems !== void 0 ? rawItems : []);
    }
  }, [complete, rawItems]);
  (0, _react.useEffect)(function () {
    if (error) {
      console.log(error);
    }
  }, [error]);
  return [{
    error: error,
    loading: loading,
    complete: complete,
    items: items,
    notFound: notFound
  }, {
    request: requestWithVars
  }];
};

var _default = useGetAwyesContent;
exports["default"] = _default;